export const MATCHES_TO_DISPLAY_PER_HIT = 2;
export const WORDS_TO_DISPLAY_PER_MATCH_CONTEXT = 20;

const MATCH_HIGHLIGHT_TAG = '<em>';
const CONTENT_BLOCKS_PROP = 'objectContentBlocks';
const WHITELISTED_HIT_KEYS = [
    'objectCardIntro',
    'objectIntro',
    // 'objectPageName' excluded. This content is already displayed as part of the search match header
    // 'objectBannerTitle' excluded. This content is already displayed as part of the search match header
    // 'objectBannerIntro' excluded. This content is duplicated by objectCardIntro
    // 'objectContentBlocks' excluded. These items are dealt with separately as they contain nested matches
    // 'Title' excluded. It is repeated in the result of the objectContentBlocks.Content property (below)
    'Content', // included. It is a property of objectContentBlocks
];

export const filterHitMatches = hit => {
    const removeMatchesAndZeroLength = key =>
        WHITELISTED_HIT_KEYS.includes(key) && hit[key].matchedWords.length > 0;

    return Object.keys(hit)
        .filter(removeMatchesAndZeroLength)
        .map(key => hit[key]);
};

export const filterHit = hit => {
    const filteredHitMatches = filterHitMatches(hit);

    const filteredObjectContentBlockMatches =
        hit[CONTENT_BLOCKS_PROP] &&
        hit[CONTENT_BLOCKS_PROP].map(o => filterHitMatches(o)).flat();

    // Show a max of 2 matches per result
    // And prioritise those within filteredObjectContentBlockMatches
    const matches = [
        ...(filteredObjectContentBlockMatches || []),
        ...filteredHitMatches,
    ].slice(0, MATCHES_TO_DISPLAY_PER_HIT);
    return matches;
};

export const trimPreceedingSentences = text => {
    // Split matchedText into sentences. Valid sentences must
    // end with a terminators of [.?!] followed by one or more spaces
    let sentences = text.split(/[.?!]\s+/);
    const firstMatchingSentenceIndex = sentences.findIndex(
        o => o && o.indexOf(MATCH_HIGHLIGHT_TAG) >= 0,
    );
    sentences = sentences
        .slice(firstMatchingSentenceIndex)
        .filter(o => o && o.trim());
    return sentences.join('. ').trim();
};

export const restrictWordLength = text => {
    const words = text.split(/\s+/);
    const matchedWords = [];
    let matchedWordProcessed = false;

    words.some(word => {
        if (
            matchedWords.length >= WORDS_TO_DISPLAY_PER_MATCH_CONTEXT &&
            matchedWordProcessed
        ) {
            return true;
        }
        matchedWords.push(word);
        matchedWordProcessed =
            matchedWordProcessed || word.indexOf(MATCH_HIGHLIGHT_TAG) >= 0;
        return false;
    });

    return matchedWords.join(' ');
};

export const formatMatch = matchedText => {
    const cleanedText = matchedText
        .replace(/&nbsp;/g, ' ')
        .replace(/[\r\n]+/g, '. ');

    const sentenceTrimmedText = trimPreceedingSentences(cleanedText);
    let wordTrimmedText = restrictWordLength(sentenceTrimmedText);

    // add an ellipses if the final text does not end with a period
    if (wordTrimmedText.charAt(wordTrimmedText.length - 1) !== '.') {
        wordTrimmedText += '&hellip;';
    }
    return wordTrimmedText;
};
